import { DocumentCategory } from '../../core-models';
import {
    buildEnumNameMap,
    getEnumValueByName,
    isEnumName,
} from './enum-name-format';

const DOCUMENT_CATEGORY_SOURCE_LABELS = {
    Other: 'Other',
    Asbestos: 'Asbestos',
    EmergencyResponsePack: 'Emergency Response Pack',
    Evacuation: 'Evacuation',
    FireSafetyCompliance: 'Fire Safety Compliance',
    FireStrategy: 'Fire Strategy',
    HealthSafetyFiles: 'Health & Safety Files',
    IncidentRiskReporting: 'Incident & Risk Reporting',
    PestControl: 'Pest Control',
    RiskAssessments: 'Risk Assessments',
    SpecificationsHealthSafetyAndCompliance: 'Specifications',
    TrainingCompetenceHealthSafetyAndCompliance: 'Training & Competence',
    BuildingApprovals: 'Building Approvals',
    ContractsConstructionAndDevelopment: 'Contracts',
    InspectionsReportsSurveysConstructionAndDevelopment:
        'Inspections, Reports & Surveys',
    Planning: 'Planning',
    PracticalCompletionDefects: 'Practical Completion & Defects',
    ProductMaterialInformation: 'Product / Material Information',
    ProjectInformation: 'Project Information',
    SpecificationsConstructionAndDevelopment: 'Specifications',
    Warranties: 'Warranties',
    CommunicationSystems: 'Communication Systems',
    ContractsBuildingOperationsAndFacilities: 'Contracts',
    ElectricalSystems: 'Electrical Systems',
    Financial: 'Financial',
    FireDoors: 'Fire Doors',
    GasSystems: 'Gas Systems',
    GreaseTrap: 'Grease Trap',
    EmbeddedNetworks: 'Embedded Networks',
    InspectionsReportsSurveysBuildingOperationsAndFacilities:
        'Inspections, Reports & Surveys',
    LifeSafetySystems: 'Life Safety Systems',
    LiftsElevators: 'Lifts / Elevators',
    OMManual: 'O&M Manual',
    OtherBuildingAssets: 'Other Building Assets',
    Permits: 'Permits',
    PoliciesProceduresStrategies: 'Policies, Procedures & Strategies',
    PressureSystems: 'Pressure Systems',
    SecuritySystems: 'Security Systems',
    Staffing: 'Staffing',
    SuppliersInformation: 'Suppliers Information',
    TrainingCompetenceBuildingOperationsAndFacilities: 'Training & Competence',
    Utilities: 'Utilities',
    VentilationSystems: 'Ventilation Systems',
    WaterSystems: 'Water Systems',
    Architectural: 'Architectural',
    CivilStructural: 'Civil / Structural',
    Mechanical: 'Mechanical',
    Electrical: 'Electrical',
    FireLifeSafety: 'Fire / Life Safety',
    Hydraulic: 'Hydraulic',
    Landscape: 'Landscape',
    FacadeCladding: 'Facade / Cladding',
    ComplianceCertificates: 'Compliance & Certificates',
    GroundGeotechnical: 'Ground & Geotechnical',
    InspectionsReportsSurveysEnvironmentalAndSite:
        'Inspections, Reports & Surveys',
    LicencesNotices: 'Licences & Notices',
    Waste: 'Waste',
    EasementsRightOfWay: 'Easements / Right of Way',
    HeadLease: 'Head Lease',
    Licences: 'Licences',
    Marketing: 'Marketing',
    PartyWall: 'Party Wall',
    RentOutgoings: 'Rent & Outgoings',
    ResidentTenantEngagement: 'Resident / Tenant Engagement',
    TenanciesUnits: 'Tenancies & Units',
    Title: 'Title',
    Transactions: 'Transactions',
    InsuranceClaimsDisputes: 'Insurance Claims & Disputes',
    InsurancePoliciesCertificates: 'Insurance Policies & Certificates',
    Tax: 'Tax',
    Valuations: 'Valuations',
} as const satisfies Readonly<Record<keyof typeof DocumentCategory, string>>;

export type DocumentCategoryName =
    (typeof DOCUMENT_CATEGORY_SOURCE_LABELS)[keyof typeof DOCUMENT_CATEGORY_SOURCE_LABELS];

export const DocumentCategoryName = buildEnumNameMap(
    DocumentCategory,
    DOCUMENT_CATEGORY_SOURCE_LABELS
);

export function getDocumentCategoryName(
    documentCategory: DocumentCategory
): DocumentCategoryName {
    return DocumentCategoryName[documentCategory];
}

export function getDocumentCategory(
    documentCategoryName: DocumentCategoryName
): DocumentCategory {
    const documentCategory = getEnumValueByName(
        DocumentCategoryName,
        documentCategoryName
    );

    if (documentCategory !== null) {
        return documentCategory;
    }

    throw new TypeError(
        `No DocumentCategory found for name: ${documentCategoryName}`
    );
}

export function isDocumentCategoryName(
    documentCategoryName: string
): documentCategoryName is DocumentCategoryName {
    return isEnumName(DocumentCategoryName, documentCategoryName);
}
